module.exports = __webpack_public_path__ + "img/security5.c91a6206.png";